"use client";

import { useCallback } from "react";

/** Seek the main asset video (data-asset-video) to t seconds and play. */
export function seekAssetVideo(t: number, selector?: string) {
  if (typeof document === "undefined") return;
  const el = document.querySelector(
    selector || "video[data-asset-video]",
  ) as HTMLVideoElement | null;
  if (!el) return;
  const safe = Math.max(0, Number(t) || 0);
  try {
    el.currentTime = safe;
    void el.play().catch(() => {
      /* autoplay may be blocked; seek still applied */
    });
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  } catch {
    /* ignore */
  }
}

export function SeekButton({
  t,
  selector,
  children,
  className,
  title,
}: {
  t: number;
  selector?: string;
  children: React.ReactNode;
  className?: string;
  title?: string;
}) {
  const onClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      seekAssetVideo(t, selector);
    },
    [t, selector],
  );
  return (
    <button type="button" onClick={onClick} className={className} title={title}>
      {children}
    </button>
  );
}
